import versionData from 'assets/JSON/appVersion.json';
export const ENV_CONFIG = {
    commonUrls:{
        googleAuthProviderId:2,
        fbAuthProviderId:3,
        appleAuthProviderId:7,
        jioIdAuthProviderId:25,
        jiocloudpcAuthProviderId:25,
        getNewOtp: "/account/login/otp/send",
        getCloudPCOtp:"/account/jioidsendotp",
        getEnterpriseLoginOTP: '/login/ent/sendotp',
        getJioIdLoginOTP : "/account/jioid/sendotp",
        otplLoginUrl: "/account/otp/login",
        enterpriseOTPLoginURL: "/login/ent/validateotp",
        jioIdVerifyOTP : "/account/jioid/verifyotp",
        socialLoginUrl: "/account/login",
        jioIdLoginUrl: "/account/jioid/useridlogin",
        jioIdValidateSSO : "/account/jioid/validatesso",
        jioMartLoginUrl: "/account/jioid/hdlsusrlogin",
        jioMartValidateSSO : "/account/jioid/hdlsvalsso",
        jiocloudpcLoginUrl: "/account/jioidjwtlogin",
        getAppSetting: "/app/settings?os=web",
        getVersionDetails: "/app/version?os=web",
        cookieUrl: "/security/web/token",
        nmsMetaData: "/nms/metadata",
        albumsMetaData:"/boards/metadata",
        getQRCodeUrl: "/account/qrcode",
        loginQRCodeUrl:"/account/qrcode/login",
        securityURL: '',
        nmsURL: '',
        trashURL: '',
        albumUploadURL: '',
        idamLoginFallbackUrl: "/account/idam/login",
        idamRefreshSSOToken: "/account/token/refresh",
        refreshToken: "/account/token/refresh",
        albums: "",
        nms: "/nms",
        createFolder:"/nms/folders",
        upload: "/upload/files/chunked/initiate",
        singleFileUpload: "/upload/files",
        chunkUpload: "/upload/files/chunked?uploadId=",
        getShareLink: "/share/links",
        albumShareLink: "/boards/links",
        sendShareLink: "/share/email",
        sendAlbumShareLink: '/boards/email',
        metaData: "/metadata",
        copy: "/metadata/copy",
        ping: "/nms/ping",
        bulkDownloadUrl: "/download/bulk/",
        shareBulkDownloadUrl: "/download/share/bulk/",
        bulkDownloadUniversalShare:"/bdl/unishr/objects",
        getShareData: "/public/share/",
        getAlbumShareData: "/public/boards/share/",
        logout: "/security/users/logout",
        shareURL: "",
        favorites: "/favorite",
        trash:"/trash",
        restore:'/restore',
        deleteforever:'/delete',
        shareRepoSummaryUrl: "/public/share/summary/",
        shareAlbumsSummaryUrl:"/public/boards/share/summary/",
        shareRepoUrl:"/public/share/",
        shareAlbumsUrl:"/public/boards/share/",
        amikoCab: "/amiko/cab/emails",
        sendEmailVerficationOtp: "/security/users/otp/send",
        verifyEmailVerficationOtp: "/security/users/otp/verify",
        getUserDetails: "/security/users",
        collabShare:'/collshare',
        sharedByMe:'/byme',
        sharedWithMe:'/withme',
        rename:'/rename',
        openSharedFolder:'/folder',
        nmsCollabShare: '/nms/collshare',
        nmsCollabShareInfo: '/nms/collshare/info',
        fileInfoComments: '/comments/',
        amikoCabSearch: "/amiko/cab/contacts/search",
        trashCollabShare: '/object/trash',
        copyFromRepoToShare:'/copyrts',
        copyFromShareToRepo:'/copystr',
        folders:'/folders',
        nestedFolder:'/nestedfolder',
        verifyEmail:'/security/users/contacts/verification',
        referEarnInvite: "/security/users/referral/invite",
        referralCodeDetails: "/security/users/referralcode",
        validateReferralCode: "/security/users/referralcode/validate",
        userPromotionsDetails: "/promotions",
        info: "/nms/metadata/",
        objectAudit: '/audit/object/',
        sharePath: '/share/',
        albumsList:'/boards/sync/initial',
        albumDetails:'/boards',
        inviteLink:'/invites/boards/',
        albumInvite:'/invites/',
        albumInvitePublic:'/invites/public/',
        easyShareToggle:'/boards/entity/dynalink/',
        shareInvite:'/share',
        deleteAlbum:'/unjoin',
        removeAlbumMembers:'/members/remove',
        albumMembersList:'/members',
        contactAPI:'/amiko/cab/contacts',
        contactSearchAPI:'/amiko/cab/contacts/search',
        coverPic:'/coverpic',
        stream:'/stream',
        acceptAlbumInvite:'/accept',
        updateTags: '/manual/tags',
        recetTags:'/nms/manual/tag/recents',
        searchQuery_: '/ase/search/suggestion',
        searchQueryV1: '/ase/search/suggestion/v1',
        searchKeyword: '/ase/search/keyword',
        aiSearchKeyword : '/smnts/search',
        aiSearchKeywordV1 : '/smnts/search/v1',
        toggleAISearch : '/smnts/userchk',
        updateAlbumCoverPic:'/metadata/coverpic',
        validate2fa: '/2fa/validation',
        sendotp2fa: '/2fa/sendotp',
        enable2fa:'/2fa/enable',
        disable2fa:'/2fa/disable',
        twoFALogout:'/2fa/logout',
        faces : '/faces',
        faceGrouping : '/faceGrouping/v1/people',
        enableFaceGrouping: '/set-user-status',
        enableFaceGroupingToggle: '/toggle',
        fetchFeedback:"/fetch-feedback",
        removeResults:"/remove-objects",
        validateAccessToken:"/nonce/validate",
        getAutoLoginToken: "/security/nonce",
        extendAllPromos:"/promo/extend/expiry",
        orderHistory:"/paidplan/orderdetails",
        selfcareRedirection:"/paidplan/selfcareredirection",
        tagsSuggestions : "/ase/suggestivetags",
        downloadInvoice:"/paidplan/invoicedwn/",
        bulkDownloadMainRepo: "/bdl/objects",
        bulkDownloadAdvShare: "/bdl/acs/objects",
        recoverAccount :"/security/accountrecover",
        recoverAccountSendOTP :"/security/accountrecover/sendotp",
        recoverAccountValidateOTP :"/security/accountrecover/validateotp",
        troubleLogin:"/account/trouble/login",
        familyStorage:"/familystorage",
        familyMembersList:"/memberdetails",
        memberEmailValidation:"/emailvalidation",
        sendInvite:"/sendinvite",
        deleteInvite:"/deleteinvite",
        deleteUser:"/deleteuser",
        validateInvite:"/validateinvite",
        submitInvite:"/submitinvite",
        leaveFamilyShare:'/leavefamily',
        univShareSummary: '/share/pulink/summary',
        getPrivateShareDC:'/nms/collshare/gethostdc/',
        getPublicShareDc:'/share/pulink/gethostdc/',
        getSMSLinkDC : "/getsmslinkdc",
        enhancedShareLink:'/share/ulinks',
        sendUniversalShareLink: "/share/ulinks/email",
        enhancedSharePublicLink: '/share/pulink',
        sharedLinkByMe: '/byme',
        univShareNewSession: '/share/pulink/get/session',
        storageInteroperability : '/sio/api',
        sioAuthUrl:'/authurl/',
        registerUser:'/register',
        linkedAccounts:'/accounts',
        pauseBackup:'/toggle',
        retryBackup:'/retrysync',
        disconnectBackup:'/disconnect',
        backupSnapshot : "/sio/api/snapshot",
        enterpriseApiURL:'/jcenterprise',
        dataUsage:'/datausages',
        entUserStats: '/jcenterprise/stats',
        getAllTeams: '/jcenterprise/team/allteam',
        entInfo: '/info',
        entSearchUser: '/users/search',
        entTeamFolderSearchUser : "/tf/usergroup/search",
        entSearchGroup: '/tf/group/search',
        entSearchByEmail: '/email',
        entUsers: '/users',
        fetchEntGroups: '/tf/groups',
        createEntGroup : '/tf/group',
        addMembersEntGroup : '/tf/group/members/add',
        deleteMembersEntGroup : '/tf/group/members/delete',
        getEntGroupMembers : '/tf/group/members',
        renameEntGroup : '/tf/group/rename',
        deleteEntGroup : '/tf/group/delete',
        entEvents: '/events',
        entActivityData: '/activitylogs',
        addEntUser : '/user/verify/email',
        entUser: '/user',
        entUserdeactivate: '/user/deactivate',
        entUseractivate: '/user/activate',
        getReport :'/report',
        csvUpload : '/user/csv',
        updateShareSetting : '/share/settings',
        boardObjectMetadata : '/boards/metadata/',
        publicDeleteShareLink : '/share/ulinks/ent/delete/_sharekey',
        publicDeleteAllShareLink : '/share/ulinks/ent/admin/delete',
        
        privateDeleteShare : '/nms/collshare/ent/admin/delete',
        privateShareMember : '/nms/collshare/sharekey/members',
        privateShareMemberUpdateAccess : '/nms/collshare',
        sharehistory : '/sharehistory',
        entNotifications: '/notifications',
        fetchCouponCode: '/promo/coupon/fetch',
        applyCouponCode: '/promo/coupon/apply',
        promocode: '/ppcppl',
        accountDelete : '/security/deleteuser',
    
        exportRequest : '/jts/takeout', //post
        exportCancel : '/jts/takeouts/', // delete 
        exportHistory : '/jts/takeouts/list', // get
        exportHistoryDetail : '/jts/takeout/metadata/', // get
       
        entSearchAll: '/jcenterprise/tf/usergroup/search?name=',
        tfPortal: '/tmfld/portal',
        tflist: '/getjtfs',
        tfDuplicate : '/duplicate/jtf',
        tfDelete : '/delete/jtf',
        tfRestore : '/restore/jtf',
        tfCreate: '/jtf',
        userTeamFolders : '/tmfld/enterprise/getjtfs',
        MSdocEditUrl : "/cspp/intg/doc/auth/",
        recentlyAccessed : "/accessdate/",
        nonadminTeamFolderMetadata : "/tmfld/metadata/jtf",
        nonadminTeamFolderMetadataOptimised : "/tmfld/metadata/jtf/myfiles/v1",
        objects : "/object",
        teamFolderMetadata : "/tmfld/metadata",
      
        nonEntConsoleTeamFolderTrashedObjects : "/tmfld/metadata/object/trash", 
        teamfolderRename : "/update/jtfname",
        teamfolderDescriptionUpdate : "/update/jtfdesc",
        teamfoldertype : "/update/jtftype",
        teamfolderexternalSharing : "/update/jtfextshare",
        teamfolderinfo : "/getjtfs/",
        teamFolderTrash : "/object/trash",
        teamFolderActivityLogs : "/audit",
        teamFolderShareLogs : "/share",
        entTeamFoldersMain : '/tmfld/enterprise',
        entTeamFoldersPortal : '/tmfld/portal',
        teamFoldersMembers : '/jtf/members', // MEMBERS
        teamFoldersMember : '/jtf/member', // MEMBER
        teamFoldersRemoveMember : '/remove',
        teamFoldersMemberRole : '/role',
        teamFolderObjectRestorePortal : "/object/restore",
        teamFolderObjectRestore : "/tmfld/metadata/object/restore",
        teamFolderEntQuota : '/tf/quota',
        teamFolderEntQuotaUpdate : '/update',
        leaveTeamFolder: "/leave/jtf ",
        teamFolderObjectCopyRepoToTF: "/tmfld/metadata/object/copy/repototf",
        teamFolderObjectCopyTFToRepo: "/tmfld/metadata/object/copy/tftorepo",
        teamFolderObjectCopyTFToTF: "/tmfld/metadata/object/copy/tftotf",
        createFolderInsideTeamFolder: "/tmfld/metadata/object/folder",
        teamFolderObjectRename: "/tmfld/metadata/object/rename",
        teamFolderObjectComments: "/tmfld/metadata/comments/",
        teamFolderObjectDeleteComments: "/tmfld/metadata/comments/delete/",
        teamFolderBulkDownload: "/bdl/tmfld/objects",
        manageVersions: "/version",
        docSupportedFormats : "/cspp/intg/doc/supported",
        getFullScreenBannerDetails : "/promo/banner/list",
        fullScreenBannerAction : "/promo/generic/action",
        privateFolderSendOTP : "/security/ppf/sendotp",
        privateFolderResetOTP : "/security/ppf/resetotp",
        privateFolderEnablePassword:'/security/ppf/enable',
        privateFolderResetPassword:'/security/ppf/reset',
        privateFolderDisable:'/security/ppf/disable',
        privateFolderPasswordValidation:'/security/ppf/validatepwd',
        privateFolderRename:'/nms/ppf/rename',
        privateFolderDelete:'/nms/metadata/ppfobject/delete',
        privateFolderObjectMove:'/nms/metadata/ppfobject/move',
        createPrivateFolder:"/nms/ppf/folders",
        captcha : "/prm/captcha",
        contactSales : "/prm/contact/jiocloud",
        
        allMemoriesList: "/nms/spotlights/metadata?page=0&limit=10",
        memoryDetail: "/nms/spotlights/metadata/",
        memoryUpdate: "/nms/spotlights/update",
        memoryObjUpdate: "/nms/spotlights/objupdate",
        ssoInit: "/sso/init",
        ssoJCLogin: "/sso/jclogin",
        faceGroupingRecommendation: "/recommendation/",
        faceGroupingMergeSuggestions : "/merge",
        faceGroupingSetCoverPic : "/coverpic",

       getRootBackupFolder: "/backup/root",
       getBackupDevices: "/backup/devices/",
       getBackupFolder: "/backup/folder/",
       nmsRecentUpload: "/mimetypefilter/recentupload/v1",
       nmsRecentObjectsHomePage : "/recent/objects",
       nmsMetadataMimeTypeFilter : "/mimetype/myfiles/v1",
       nmsMetadataDefaultviewMyfiles : "/defaultview/myfiles/v1",

       getIcloudBackupSummery: "/icl/summary",
       iClouAuth: "/icl/auth/signin",
       icloudTokenValidation: "/icl/validate/token",
       initializeTransfer: "/icl/process/init",
       getIcloudBackupStatus: "/icl/process/status",
       getFileTransferedStatus:"/icl/transfer/snapshot",
       resyncIcloudBackup : "/icl/deltasync",
       transferFailedFiles: "/failed/files",
       memoryAnalytics : "/promo/generic/action",
       nmsHeadless: "/nms/headless",
       linkedApps: "/linkedapp",
       digiWalletFetchDocsApi: "/digi/docs",
       digiWalletCopyDocsApi: "/digi/copy",
       userFeture: "/security/userfeatures",
       
       getSearchFeedbackOption: "/promo/feedback/smntfb",
       submitSearchFeedback: "/promo/generic/action",
       getSearchStatus : "/smnts/status",
       nmsHeadlessLinkedAppsApi : "/headless/linkedapps", //Apps
       nmsHeadlessLinkedAppApi : "/headless/linkedapp", //Linked App - not to append 's', for single app
       eventPlayStore : "https://play.google.com/store/apps/details?id=jio.cloud.drive&referrer=",
       eventAppStore : "https://apps.apple.com/in/app/jioaicloud-live-intelligently/id1001974993",

       appEvent : "/jca/client/appevents",
       places: "/places",
       placesObjects : "/objects?placekey="

    },
    
    commonHeaders: {
        "Content-Type": "application/json; charset=UTF-8",
        "Accept": "application/json; charset=UTF-8",
        "X-Device-Type": "W",
        "Upload-Chunk-Content-Type": "application/octet-stream"
    },
    
    thirdpartyUrls:{
        myjio:"https://jio.com/",
    },

    appDownloadUrls:{
        mobileClient:{
          appStore:"https://itunes.apple.com/in/app/jiocloud/id1001974993?mt=8",
          playStore:'https://play.google.com/store/apps/details?id=jio.cloud.drive&referrer=utm_source%3Dwebdownload'
        },
        windowsClient:{
          DEV: "https://static.jiocloud.com/dclient/windows/JioAICloud.exe?utm_source=webpage&utm_campaign=download",
          SIT: "https://static.jiocloud.com/dclient/windows/JioAICloud.exe?utm_source=webpage&utm_campaign=download",
          PREPROD: "https://static.jiocloud.com/dclient/windows/JioAICloud.exe?utm_source=webpage&utm_campaign=download",
          PROD: "https://static.jiocloud.com/dclient/windows/JioAICloud.exe?utm_source=webpage&utm_campaign=download"
        },
        macClient:{
          DEV: "https://apps.apple.com/us/app/jiocloud-desktop/id6449248730",
          SIT: "https://apps.apple.com/us/app/jiocloud-desktop/id6449248730",
          PREPROD: "https://apps.apple.com/us/app/jiocloud-desktop/id6449248730",
          PROD: "https://apps.apple.com/us/app/jiocloud-desktop/id6449248730"
        }
    
      },
    docEditSupportedFormats:['Document','Presentation','SpreadSheet','unknown'],
    routesToSkipCheckingLoginStatus : ["webview","/a?t","sso","jctoken","clbkinweb","2A7zJj_xG_8Z9ePm"],
    photoEditSupportedExtensions : [".jpg",".jpeg",".png",".webp"],

    jsonUrls : {
      tabbedView : 'assets/JSON/tabbed-view.json' + '?av='+versionData.appVersion,
      topMenu : 'assets/JSON/top-menu.json'+ '?av='+versionData.appVersion,
      topMenuMobile : 'assets/JSON/top-menu-mobile.json'+ '?av='+versionData.appVersion,
      contextMenu : 'assets/JSON/context-menu.json'+ '?av='+versionData.appVersion,
      fileInfo : 'assets/JSON/file-info.json'+ '?av='+versionData.appVersion,
      leftMenu : 'assets/JSON/left-menu.json'+ '?av='+versionData.appVersion,
      newLeftMenu : 'assets/JSON/new-left-menu.json'+ '?av='+versionData.appVersion,
      favouritesAlbumsMobile : 'assets/JSON/favorites-albums-mobile.json'+ '?av='+versionData.appVersion,
      sharedByMeMobile : 'assets/JSON/shared-files/mobile/shared-by-me.json'+ '?av='+versionData.appVersion,
      sharedWithMeMobile : 'assets/JSON/shared-files/mobile/shared-with-me.json'+ '?av='+versionData.appVersion,
      favouritesAlbumsDesktop : 'assets/JSON/favorites-albums-menu.json'+ '?av='+versionData.appVersion,
      sharedByMeDesktop : 'assets/JSON/shared-files/desktop/shared-by-me.json'+ '?av='+versionData.appVersion,
      sharedWithMeDesktop : 'assets/JSON/shared-files/desktop/shared-with-me.json'+ '?av='+versionData.appVersion,
      entMoreOption : 'assets/JSON/ent-more-option.json'+ '?av='+versionData.appVersion,
      entListHeader : 'assets/JSON/ent-list-header.json'+ '?av='+versionData.appVersion,
      tableHeader : 'assets/JSON/table-headers.json'+ '?av='+versionData.appVersion,
      versionMenu : 'assets/JSON/version-menu.json'+ '?av='+versionData.appVersion,
      officeForWeb  : 'assets/JSON/office-for-web-menu.json'+ '?av='+versionData.appVersion,
      cloudplatformUrls :'assets/JSON/cloud-platforms.json'+ '?av='+versionData.appVersion,
    },
    constants:{
      tableListPaginationLimit : 10,
      planExpiryDate : 4102358400000,
      PAGINATION_BUFFER : 2,
      PAGE_LIMIT : 100,
      defaultDCGroupCode : "JAWS"
    },


    BROWSER_SUPPORT:{ // as the bundling target is ES2022, these versions are specific to ES2022 we have to change this whenever bundle target is changed
      "Chrome" : {major : 92, minor : 0},
      "Microsoft Edge" : {major : 92, minor : 0},
      "Firefox" : {major : 90, minor : 0},
      "Safari" : {major : 15, minor : 4},
      "Opera" : {major : 77, minor : 0},
    }
      
}
